import { render, staticRenderFns } from "./UserShopCartProductDetail.vue?vue&type=template&id=dd4e2ec4"
import script from "./UserShopCartProductDetail.vue?vue&type=script&lang=js"
export * from "./UserShopCartProductDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports